const infostext = [
  {
    title: "Des chauffeurs professionnels soucieux de l'environnement",
    text:
      "Nos chauffeurs professionnels sont engagés envers l'environnement et s'efforcent de fournir un service de qualité tout en minimisant notre impact sur la planète. Dans notre entreprise familiale de taxi électrique, nous croyons en la nécessité d'adopter des solutions de transport durables pour préserver notre environnement et assurer un avenir meilleur.",
  },
  {
    title: 'Une expérience hors du commun',
    text:
      "Découvrez une expérience de transport unique avec notre entreprise familiale de taxi électrique. Nous combinons notre passion pour les véhicules électriques et notre engagement envers un service client exceptionnel pour vous offrir un voyage inoubliable. Profitez d'un trajet confortable, respectueux de l'environnement et réalisé par des chauffeurs expérimentés qui ont à cœur votre satisfaction.",
  },
  {
    title: "Rejoignez-nous",
    text:
      "Vous souhaitez rejoindre une entreprise familiale dynamique et axée sur l'avenir ? Rejoignez notre équipe de chauffeurs de taxi électrique. Nous offrons un environnement de travail convivial, des opportunités de développement professionnel et la possibilité de contribuer à la transition vers une mobilité plus durable. Rejoignez-nous et participez à la création d'un avenir meilleur pour tous.",
  },
];

export default infostext;
